"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetCatalogueSharingLink = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _tsUtils = require("@ori/ts-utils");
var _contexts = require("../contexts");
var _net = require("../models/graphql-types/net");
var _queriesNet = require("../queries-net");
var _utils = require("../utils");
/* istanbul ignore file @preserve */

const useGetCatalogueSharingLink = ({
  currentStore
}) => {
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    headers,
    loading: loadingHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    cataloguePageNumber,
    catalogueId,
    type
  } = (0, _contexts.useFeedbackBenefitDialog)();
  const {
    data,
    error
  } = (0, _fetching.useGraphqlQuery)({
    query: _queriesNet.catalogueDynamicUrl,
    url: graphQlNetUrl,
    headers,
    variables: {
      catalogueId: catalogueId ?? '',
      storeName: currentStore,
      pageNumber: cataloguePageNumber
    },
    skip: (0, _utils.shouldSkipCatalogueLinkQuery)({
      loadingHeaders,
      type,
      cataloguePageNumber,
      catalogueId
    }),
    swrConfig: {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false
    }
  });
  return {
    dynamicLink: data?.application?.sharingLinks?.otherCatalogue.dynamicSharingUrl,
    loading: type === _net.FeedbackBenefitBannerType.ShareAndEarn && (0, _tsUtils.isNonNullable)(cataloguePageNumber) && !data && !error
  };
};
exports.useGetCatalogueSharingLink = useGetCatalogueSharingLink;
